import { AdminTemplate } from "../../components";
import {AddProductWithExcel} from "../../components/organisms/softpos/AddProductWithExcel";

export const AddProductWithExcelPage = () => {

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Toplu Ürün Ekle",
        hideAddButton: true
      }}
    >
      <AddProductWithExcel />
    </AdminTemplate>
  );
};
